// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Lt46","colMin":"styles_colMin__OYyna"};